const templateConfig = {
  run: {
    access: 0,
    authorId: '0',
    createTimestamp: 0,
    distance: 0,
    duration: 0,
    essence: 0,
    estimatedType: 0,
    estimatedValue: 0,
    exerciseNum: 0,
    exercises: [
      {
        access: 0,
        createTimestamp: 1586584068,
        defaultOrder: 1,
        equipment: [1],
        exerciseType: 1,
        groupId: '0',
        hrType: 3,
        id: '1',
        intensityCustom: 2,
        intensityDisplayUnit: 0,
        intensityMultiplier: 0,
        intensityPercent: 0,
        intensityPercentExtend: 0,
        intensityType: 2,
        intensityValue: 0,
        intensityValueExtend: 0,
        isDefaultAdd: 0,
        isGroup: false,
        isIntensityPercent: false,
        name: 'T1120',
        originId: '425895398452936705',
        overview: 'sid_run_warm_up_dist',
        part: [0],
        restType: 3,
        restValue: 0,
        sets: 1,
        sortNo: 1,
        sourceId: '0',
        sourceUrl: '',
        sportType: 1,
        subType: 0,
        targetDisplayUnit: 0,
        targetType: 2,
        targetValue: 300,
        userId: 0,
        videoUrl: ''
      },
      {
        access: 0,
        createTimestamp: 0,
        defaultOrder: 0,
        exerciseType: 0,
        groupId: '0',
        hrType: 0,
        id: '2',
        intensityCustom: 0,
        intensityDisplayUnit: 0,
        intensityMultiplier: 0,
        intensityPercent: 0,
        intensityPercentExtend: 0,
        intensityType: 0,
        intensityValue: 0,
        intensityValueExtend: 0,
        isDefaultAdd: 0,
        isGroup: true,
        isIntensityPercent: false,
        name: '',
        originId: '2',
        overview: '',
        restType: 0,
        restValue: 0,
        sets: 1,
        sortNo: 2,
        sourceId: '0',
        sourceUrl: '',
        sportType: 0,
        subType: 0,
        targetDisplayUnit: 0,
        targetType: 0,
        targetValue: 0,
        userId: 0,
        videoUrl: ''
      },
      {
        access: 0,
        createTimestamp: 1587381919,
        defaultOrder: 2,
        equipment: [1],
        exerciseType: 2,
        groupId: '2',
        hrType: 3,
        id: '3',
        intensityCustom: 2,
        intensityDisplayUnit: 0,
        intensityMultiplier: 0,
        intensityPercent: 0,
        intensityPercentExtend: 0,
        intensityType: 2,
        intensityValue: 0,
        intensityValueExtend: 0,
        isDefaultAdd: 1,
        isGroup: false,
        isIntensityPercent: false,
        name: 'T3001',
        originId: '426109589008859136',
        overview: 'sid_run_training',
        part: [0],
        restType: 3,
        restValue: 0,
        sets: 1,
        sortNo: 3,
        sourceId: '0',
        sourceUrl: '',
        sportType: 1,
        subType: 0,
        targetDisplayUnit: 0,
        targetType: 2,
        targetValue: 300,
        userId: 0,
        videoUrl: ''
      },
      {
        access: 0,
        createTimestamp: 1586584214,
        defaultOrder: 3,
        equipment: [1],
        exerciseType: 4,
        groupId: '2',
        hrType: 3,
        id: '4',
        intensityCustom: 2,
        intensityDisplayUnit: 0,
        intensityMultiplier: 0,
        intensityPercent: 0,
        intensityPercentExtend: 0,
        intensityType: 2,
        intensityValue: 0,
        intensityValueExtend: 0,
        isDefaultAdd: 0,
        isGroup: false,
        isIntensityPercent: false,
        name: 'T1123',
        originId: '425895398452936705',
        overview: 'sid_run_cool_down_dist',
        part: [0],
        restType: 3,
        restValue: 0,
        sets: 1,
        sortNo: 4,
        sourceId: '0',
        sourceUrl: '',
        sportType: 1,
        subType: 0,
        targetDisplayUnit: 0,
        targetType: 2,
        targetValue: 300,
        userId: 0,
        videoUrl: ''
      },
      {
        access: 0,
        createTimestamp: 1586584214,
        defaultOrder: 3,
        equipment: [1],
        exerciseType: 3,
        groupId: '0',
        hrType: 3,
        id: '5',
        intensityCustom: 2,
        intensityDisplayUnit: 0,
        intensityMultiplier: 0,
        intensityPercent: 0,
        intensityPercentExtend: 0,
        intensityType: 2,
        intensityValue: 0,
        intensityValueExtend: 0,
        isDefaultAdd: 0,
        isGroup: false,
        isIntensityPercent: false,
        name: 'T1122',
        originId: '425895456971866112',
        overview: 'sid_run_cool_down_dist',
        part: [0],
        restType: 3,
        restValue: 0,
        sets: 1,
        sortNo: 5,
        sourceId: '0',
        sourceUrl: '',
        sportType: 1,
        subType: 0,
        targetDisplayUnit: 0,
        targetType: 2,
        targetValue: 300,
        userId: 0,
        videoUrl: ''
      }
    ],
    headPic: '',
    id: '0',
    idInPlan: '0',
    name: '',
    nickname: '',
    originEssence: 0,
    overview: '',
    pbVersion: 2,
    planIdIndex: 0,
    poolLength: 0,
    profile: '',
    referExercise: {
      hrType: 0,
      intensityType: 0,
      valueType: 0
    },
    sex: 0,
    shareUrl: '',
    simple: false,
    sourceUrl: '',
    sportType: 1,
    star: 0,
    subType: 65535,
    targetType: 0,
    targetValue: 0,
    thirdPartyId: 0,
    totalSets: 0,
    trainingLoad: 0,
    type: 0,
    unit: 0,
    userId: '0',
    version: 0,
    videoCoverUrl: '',
    videoUrl: ''
  },
  trailRun: {
    access: 0,
    authorId: '0',
    createTimestamp: 0,
    distance: 0,
    duration: 0,
    essence: 0,
    estimatedType: 0,
    estimatedValue: 0,
    exerciseNum: 0,
    exercises: [
      {
        access: 0,
        createTimestamp: 1586584068,
        defaultOrder: 1,
        equipment: [1],
        exerciseType: 1,
        groupId: '0',
        hrType: 3,
        id: '1',
        intensityCustom: 2,
        intensityDisplayUnit: 0,
        intensityMultiplier: 0,
        intensityPercent: 0,
        intensityPercentExtend: 0,
        intensityType: 2,
        intensityValue: 0,
        intensityValueExtend: 0,
        isDefaultAdd: 0,
        isGroup: false,
        isIntensityPercent: false,
        name: 'T1120',
        originId: '425895398452936705',
        overview: 'sid_run_warm_up_dist',
        part: [0],
        restType: 3,
        restValue: 0,
        sets: 1,
        sortNo: 1,
        sourceId: '0',
        sourceUrl: '',
        sportType: 5,
        subType: 0,
        targetDisplayUnit: 0,
        targetType: 2,
        targetValue: 300,
        userId: 0,
        videoUrl: ''
      },
      {
        access: 0,
        createTimestamp: 0,
        defaultOrder: 0,
        exerciseType: 0,
        groupId: '0',
        hrType: 0,
        id: '2',
        intensityCustom: 0,
        intensityDisplayUnit: 0,
        intensityMultiplier: 0,
        intensityPercent: 0,
        intensityPercentExtend: 0,
        intensityType: 0,
        intensityValue: 0,
        intensityValueExtend: 0,
        isDefaultAdd: 0,
        isGroup: true,
        isIntensityPercent: false,
        name: '',
        originId: '2',
        overview: '',
        restType: 0,
        restValue: 0,
        sets: 1,
        sortNo: 2,
        sourceId: '0',
        sourceUrl: '',
        sportType: 0,
        subType: 0,
        targetDisplayUnit: 0,
        targetType: 0,
        targetValue: 0,
        userId: 0,
        videoUrl: ''
      },
      {
        access: 0,
        createTimestamp: 1587381919,
        defaultOrder: 2,
        equipment: [1],
        exerciseType: 2,
        groupId: '2',
        hrType: 3,
        id: '3',
        intensityCustom: 2,
        intensityDisplayUnit: 0,
        intensityMultiplier: 0,
        intensityPercent: 0,
        intensityPercentExtend: 0,
        intensityType: 2,
        intensityValue: 0,
        intensityValueExtend: 0,
        isDefaultAdd: 1,
        isGroup: false,
        isIntensityPercent: false,
        name: 'T3001',
        originId: '426109589008859136',
        overview: 'sid_run_training',
        part: [0],
        restType: 3,
        restValue: 0,
        sets: 1,
        sortNo: 3,
        sourceId: '0',
        sourceUrl: '',
        sportType: 5,
        subType: 0,
        targetDisplayUnit: 0,
        targetType: 2,
        targetValue: 300,
        userId: 0,
        videoUrl: ''
      },
      {
        access: 0,
        createTimestamp: 1586584214,
        defaultOrder: 3,
        equipment: [1],
        exerciseType: 4,
        groupId: '2',
        hrType: 3,
        id: '4',
        intensityCustom: 2,
        intensityDisplayUnit: 0,
        intensityMultiplier: 0,
        intensityPercent: 0,
        intensityPercentExtend: 0,
        intensityType: 2,
        intensityValue: 0,
        intensityValueExtend: 0,
        isDefaultAdd: 0,
        isGroup: false,
        isIntensityPercent: false,
        name: 'T1123',
        originId: '425895398452936705',
        overview: 'sid_run_cool_down_dist',
        part: [0],
        restType: 3,
        restValue: 0,
        sets: 1,
        sortNo: 4,
        sourceId: '0',
        sourceUrl: '',
        sportType: 5,
        subType: 0,
        targetDisplayUnit: 0,
        targetType: 2,
        targetValue: 300,
        userId: 0,
        videoUrl: ''
      },
      {
        access: 0,
        createTimestamp: 1586584214,
        defaultOrder: 3,
        equipment: [1],
        exerciseType: 3,
        groupId: '0',
        hrType: 3,
        id: '5',
        intensityCustom: 2,
        intensityDisplayUnit: 0,
        intensityMultiplier: 0,
        intensityPercent: 0,
        intensityPercentExtend: 0,
        intensityType: 2,
        intensityValue: 0,
        intensityValueExtend: 0,
        isDefaultAdd: 0,
        isGroup: false,
        isIntensityPercent: false,
        name: 'T1122',
        originId: '425895456971866112',
        overview: 'sid_run_cool_down_dist',
        part: [0],
        restType: 3,
        restValue: 0,
        sets: 1,
        sortNo: 5,
        sourceId: '0',
        sourceUrl: '',
        sportType: 5,
        subType: 0,
        targetDisplayUnit: 0,
        targetType: 2,
        targetValue: 300,
        userId: 0,
        videoUrl: ''
      }
    ],
    headPic: '',
    id: '0',
    idInPlan: '0',
    name: '',
    nickname: '',
    originEssence: 0,
    overview: '',
    // 新增训练类型和其它旧训练类型区分
    pbVersion: 4,
    planIdIndex: 0,
    poolLength: 0,
    profile: '',
    referExercise: {
      hrType: 0,
      intensityType: 0,
      valueType: 0
    },
    sex: 0,
    shareUrl: '',
    simple: false,
    sourceUrl: '',
    sportType: 5,
    star: 0,
    subType: 65535,
    targetType: 0,
    targetValue: 0,
    thirdPartyId: 0,
    totalSets: 0,
    trainingLoad: 0,
    type: 0,
    unit: 0,
    userId: '0',
    version: 0,
    videoCoverUrl: '',
    videoUrl: ''
  },
  bike: {
    access: 0,
    authorId: '0',
    createTimestamp: 0,
    distance: 0,
    duration: 0,
    essence: 0,
    estimatedType: 0,
    estimatedValue: 0,
    exerciseNum: 0,
    exercises: [
      {
        access: 0,
        createTimestamp: 1586585721,
        defaultOrder: 1,
        equipment: [1],
        exerciseType: 1,
        groupId: '0',
        hrType: 3,
        id: '1',
        intensityCustom: 2,
        intensityDisplayUnit: 0,
        intensityMultiplier: 0,
        intensityPercent: 0,
        intensityPercentExtend: 0,
        intensityType: 2,
        intensityValue: 0,
        intensityValueExtend: 0,
        isDefaultAdd: 0,
        isGroup: false,
        isIntensityPercent: false,
        name: 'T1120',
        originId: '425895398452936705',
        overview: 'sid_bike_warm_up_dist',
        part: [0],
        restType: 3,
        restValue: 0,
        sets: 1,
        sortNo: 1,
        sourceId: '0',
        sourceUrl: '',
        sportType: 2,
        subType: 0,
        targetDisplayUnit: 0,
        targetType: 2,
        targetValue: 300,
        userId: 0,
        videoUrl: ''
      },
      {
        access: 0,
        createTimestamp: 0,
        defaultOrder: 0,
        exerciseType: 0,
        groupId: '0',
        hrType: 0,
        id: '2',
        intensityCustom: 0,
        intensityDisplayUnit: 0,
        intensityMultiplier: 0,
        intensityPercent: 0,
        intensityPercentExtend: 0,
        intensityType: 0,
        intensityValue: 0,
        intensityValueExtend: 0,
        isDefaultAdd: 0,
        isGroup: true,
        isIntensityPercent: false,
        name: '',
        originId: '2',
        overview: '',
        restType: 0,
        restValue: 0,
        sets: 1,
        sortNo: 2,
        sourceId: '0',
        sourceUrl: '',
        sportType: 0,
        subType: 0,
        targetDisplayUnit: 0,
        targetType: 0,
        targetValue: 0,
        userId: 0,
        videoUrl: ''
      },
      {
        access: 0,
        createTimestamp: 1586585061,
        defaultOrder: 2,
        equipment: [1],
        exerciseType: 2,
        groupId: '2',
        hrType: 3,
        id: '3',
        intensityCustom: 2,
        intensityDisplayUnit: 0,
        intensityMultiplier: 0,
        intensityPercent: 0,
        intensityPercentExtend: 0,
        intensityType: 2,
        intensityValue: 0,
        intensityValueExtend: 0,
        isDefaultAdd: 1,
        isGroup: false,
        isIntensityPercent: false,
        name: 'T4000',
        originId: '426109589008859136',
        overview: 'sid_bike_dist_speed',
        part: [0],
        restType: 3,
        restValue: 0,
        sets: 1,
        sortNo: 3,
        sourceId: '0',
        sourceUrl: '',
        sportType: 2,
        subType: 0,
        targetDisplayUnit: 0,
        targetType: 2,
        targetValue: 300,
        userId: 0,
        videoUrl: ''
      },
      {
        access: 0,
        createTimestamp: 1586585838,
        defaultOrder: 3,
        equipment: [1],
        exerciseType: 4,
        groupId: '2',
        hrType: 3,
        id: '4',
        intensityCustom: 2,
        intensityDisplayUnit: 0,
        intensityMultiplier: 0,
        intensityPercent: 0,
        intensityPercentExtend: 0,
        intensityType: 2,
        intensityValue: 0,
        intensityValueExtend: 0,
        isDefaultAdd: 0,
        isGroup: false,
        isIntensityPercent: false,
        name: 'T1123',
        originId: '425895398452936705',
        overview: 'sid_bike_cool_down_dist',
        part: [0],
        restType: 3,
        restValue: 0,
        sets: 1,
        sortNo: 4,
        sourceId: '0',
        sourceUrl: '',
        sportType: 2,
        subType: 0,
        targetDisplayUnit: 0,
        targetType: 2,
        targetValue: 300,
        userId: 0,
        videoUrl: ''
      },
      {
        access: 0,
        createTimestamp: 1586585838,
        defaultOrder: 3,
        equipment: [1],
        exerciseType: 3,
        groupId: '0',
        hrType: 3,
        id: '5',
        intensityCustom: 2,
        intensityDisplayUnit: 0,
        intensityMultiplier: 0,
        intensityPercent: 0,
        intensityPercentExtend: 0,
        intensityType: 2,
        intensityValue: 0,
        intensityValueExtend: 0,
        isDefaultAdd: 0,
        isGroup: false,
        isIntensityPercent: false,
        name: 'T1122',
        originId: '425895456971866112',
        overview: 'sid_bike_cool_down_dist',
        part: [0],
        restType: 3,
        restValue: 0,
        sets: 1,
        sortNo: 5,
        sourceId: '0',
        sourceUrl: '',
        sportType: 2,
        subType: 0,
        targetDisplayUnit: 0,
        targetType: 2,
        targetValue: 300,
        userId: 0,
        videoUrl: ''
      }
    ],
    headPic: '',
    id: '0',
    idInPlan: '0',
    name: '',
    nickname: '',
    originEssence: 0,
    overview: '',
    pbVersion: 2,
    planIdIndex: 0,
    poolLength: 0,
    profile: '',
    referExercise: {
      hrType: 0,
      intensityType: 0,
      valueType: 0
    },
    sex: 0,
    shareUrl: '',
    simple: false,
    sourceUrl: '',
    sportType: 2,
    star: 0,
    subType: 65535,
    targetType: 0,
    targetValue: 0,
    thirdPartyId: 0,
    totalSets: 0,
    trainingLoad: 0,
    type: 0,
    unit: 0,
    userId: '0',
    version: 0,
    videoCoverUrl: '',
    videoUrl: ''
  },
  swim: {
    access: 0,
    authorId: '0',
    createTimestamp: 0,
    distance: 0,
    duration: 0,
    essence: 0,
    estimatedType: 0,
    estimatedValue: 0,
    exerciseNum: 0,
    exercises: [
      // 热身
      {
        access: 0,
        createTimestamp: 1586586898,
        defaultOrder: 1,
        equipment: [1],
        exerciseType: 1,
        groupId: '0',
        hrType: 0,
        id: '1',
        intensityCustom: 0,
        intensityDisplayUnit: 0,
        intensityMultiplier: 0,
        intensityPercent: 0,
        intensityPercentExtend: 0,
        intensityType: 5,
        intensityValue: 1,
        intensityValueExtend: 0,
        isDefaultAdd: 0,
        isGroup: false,
        isIntensityPercent: false,
        name: 'T1120',
        originId: '425895398452936705',
        overview: 'sid_poolswim_warm_up_dist',
        part: [0],
        restType: 3,
        restValue: 0,
        sets: 1,
        sortNo: 1,
        sourceId: '0',
        sourceUrl: '',
        sportType: 3,
        subType: 0,
        targetDisplayUnit: 2,
        targetType: 5,
        targetValue: 10000000,
        userId: 0,
        videoUrl: ''
      },
      // 分组
      {
        access: 0,
        createTimestamp: 0,
        defaultOrder: 0,
        exerciseType: 0,
        groupId: '0',
        hrType: 0,
        id: '2',
        intensityCustom: 0,
        intensityDisplayUnit: 0,
        intensityMultiplier: 0,
        intensityPercent: 0,
        intensityPercentExtend: 0,
        intensityType: 0,
        intensityValue: 0,
        intensityValueExtend: 0,
        isDefaultAdd: 0,
        isGroup: true,
        isIntensityPercent: false,
        name: '',
        originId: '2',
        overview: '',
        restType: 0,
        restValue: 0,
        sets: 1,
        sortNo: 2,
        sourceId: '0',
        sourceUrl: '',
        sportType: 0,
        subType: 0,
        targetDisplayUnit: 0,
        targetType: 0,
        targetValue: 100,
        userId: 0,
        videoUrl: ''
      },
      // 动作
      {
        access: 0,
        createTimestamp: 1586586026,
        defaultOrder: 2,
        equipment: [1],
        exerciseType: 2,
        groupId: '2',
        hrType: 0,
        id: '3',
        intensityCustom: 0,
        intensityDisplayUnit: 0,
        intensityMultiplier: 0,
        intensityPercent: 0,
        intensityPercentExtend: 0,
        intensityType: 5,
        intensityValue: 1,
        intensityValueExtend: 0,
        isDefaultAdd: 1,
        isGroup: false,
        isIntensityPercent: false,
        name: 'T5000',
        originId: '426109589008859136',
        overview: 'sid_poolswim_dist_default',
        part: [0],
        restType: 3,
        restValue: 0,
        sets: 1,
        sortNo: 3,
        sourceId: '0',
        sourceUrl: '',
        sportType: 3,
        subType: 0,
        targetDisplayUnit: 2,
        targetType: 5,
        // 100m
        targetValue: 10000000,
        userId: 0,
        videoUrl: ''
      },
      // 休息
      {
        access: 0,
        createTimestamp: 1586587031,
        defaultOrder: 3,
        equipment: [1],
        exerciseType: 4,
        groupId: '2',
        hrType: 0,
        id: '4',
        intensityCustom: 0,
        intensityDisplayUnit: 0,
        intensityMultiplier: 0,
        intensityPercent: 0,
        intensityPercentExtend: 0,
        intensityType: 5,
        intensityValue: 0,
        intensityValueExtend: 0,
        isDefaultAdd: 0,
        isGroup: false,
        isIntensityPercent: false,
        name: 'T1123',
        originId: '425895398452936705',
        overview: 'sid_poolswim_cool_down_dist',
        part: [0],
        restType: 3,
        restValue: 0,
        sets: 1,
        sortNo: 4,
        sourceId: '0',
        sourceUrl: '',
        sportType: 3,
        subType: 0,
        targetDisplayUnit: 0,
        targetType: 2,
        targetValue: 300,
        userId: 0,
        videoUrl: ''
      },
      // 放松
      {
        access: 0,
        createTimestamp: 1586587031,
        defaultOrder: 3,
        equipment: [1],
        exerciseType: 3,
        groupId: '0',
        hrType: 0,
        id: '5',
        intensityCustom: 0,
        intensityDisplayUnit: 0,
        intensityMultiplier: 0,
        intensityPercent: 0,
        intensityPercentExtend: 0,
        intensityType: 5,
        intensityValue: 1,
        intensityValueExtend: 0,
        isDefaultAdd: 0,
        isGroup: false,
        isIntensityPercent: false,
        name: 'T1122',
        originId: '425895456971866112',
        overview: 'sid_poolswim_cool_down_dist',
        part: [0],
        restType: 3,
        restValue: 0,
        sets: 1,
        sortNo: 5,
        sourceId: '0',
        sourceUrl: '',
        sportType: 3,
        subType: 0,
        targetDisplayUnit: 2,
        targetType: 5,
        targetValue: 10000000,
        userId: 0,
        videoUrl: ''
      }
    ],
    headPic: '',
    id: '0',
    idInPlan: '0',
    name: '',
    nickname: '',
    originEssence: 0,
    overview: '',
    pbVersion: 2,
    planIdIndex: 0,
    poolLength: 0,
    profile: '',
    referExercise: {
      hrType: 0,
      intensityType: 0
    },
    sex: 0,
    shareUrl: '',
    simple: false,
    sourceUrl: '',
    sportType: 3,
    star: 0,
    subType: 65535,
    targetType: 0,
    targetValue: 0,
    thirdPartyId: 0,
    totalSets: 0,
    trainingLoad: 0,
    type: 0,
    unit: 0,
    userId: '0',
    version: 0,
    videoCoverUrl: '',
    videoUrl: ''
  },
  strength: {
    access: 0,
    authorId: '0',
    createTimestamp: 0,
    distance: 0,
    duration: 0,
    essence: 0,
    estimatedType: 0,
    estimatedValue: 0,
    exerciseNum: 0,
    exercises: [
      {
        access: 0,
        createTimestamp: 1586597188,
        defaultOrder: 2,
        exerciseType: 2,
        hrType: 0,
        id: '2',
        intensityCustom: 0,
        intensityDisplayUnit: 0,
        intensityMultiplier: 0,
        intensityPercent: 0,
        intensityPercentExtend: 0,
        intensityType: 1,
        intensityValue: 0,
        intensityValueExtend: 0,
        isDefaultAdd: 0,
        isGroup: false,
        isIntensityPercent: false,
        name: 'S4652',
        originId: '426109589008859136',
        overview: 'sid_strength_training',
        part: [0],
        restType: 1,
        restValue: 60,
        sets: 1,
        sortNo: 2,
        sourceId: '0',
        sourceUrl: '',
        sportType: 4,
        subType: 0,
        targetDisplayUnit: 0,
        targetType: 3,
        targetValue: 15,
        userId: 0,
        videoUrl: ''
      }
    ],
    headPic: '',
    id: '0',
    idInPlan: '0',
    name: '',
    nickname: '',
    originEssence: 0,
    overview: '',
    pbVersion: 2,
    planIdIndex: 0,
    poolLength: 0,
    profile: '',
    referExercise: {
      hrType: 0,
      intensityType: 0
    },
    sex: 0,
    shareUrl: '',
    simple: false,
    sourceUrl: '',
    sportType: 4,
    star: 0,
    subType: 65535,
    targetType: 0,
    targetValue: 0,
    thirdPartyId: 0,
    totalSets: 0,
    trainingLoad: 0,
    type: 0,
    unit: 0,
    userId: '0',
    version: 0,
    videoCoverUrl: '',
    videoUrl: ''
  },
  indoorClimb: {
    access: 0,
    authorId: '0',
    createTimestamp: 0,
    distance: 0,
    duration: 0,
    essence: 0,
    estimatedType: 0,
    estimatedValue: 0,
    exerciseNum: 0,
    exercises: [
      {
        access: 0,
        createTimestamp: 1586584068,
        defaultOrder: 1,
        equipment: [1],
        exerciseType: 1,
        groupId: '0',
        hrType: 0,
        id: '1',
        intensityCustom: 0,
        intensityDisplayUnit: 0,
        intensityMultiplier: 0,
        intensityPercent: 0,
        intensityPercentExtend: 0,
        intensityType: 10,
        intensityValue: 0,
        intensityValueExtend: 0,
        isDefaultAdd: 0,
        isGroup: false,
        isIntensityPercent: false,
        name: 'T1120',
        originId: '425895398452936705',
        overview: 'sid_run_warm_up_dist',
        part: [0],
        restType: 3,
        restValue: 0,
        sets: 1,
        sortNo: 1,
        sourceId: '0',
        sourceUrl: '',
        sportType: 6,
        subType: 0,
        targetDisplayUnit: 0,
        targetType: 9,
        targetValue: 2,
        userId: 0,
        videoUrl: '',
        onsightGradeOffset: 30
      },
      {
        access: 0,
        createTimestamp: 0,
        defaultOrder: 0,
        exerciseType: 0,
        groupId: '0',
        hrType: 0,
        id: '2',
        intensityCustom: 0,
        intensityDisplayUnit: 0,
        intensityMultiplier: 0,
        intensityPercent: 0,
        intensityPercentExtend: 0,
        intensityType: 10,
        intensityValue: 0,
        intensityValueExtend: 0,
        isDefaultAdd: 0,
        isGroup: true,
        isIntensityPercent: false,
        name: '',
        originId: '2',
        overview: '',
        restType: 0,
        restValue: 0,
        sets: 1,
        sortNo: 2,
        sourceId: '0',
        sourceUrl: '',
        sportType: 6,
        subType: 0,
        targetDisplayUnit: 0,
        targetType: 9,
        targetValue: 1,
        userId: 0,
        videoUrl: '',
        onsightGradeOffset: 0
      },
      {
        access: 0,
        createTimestamp: 1587381919,
        defaultOrder: 2,
        equipment: [1],
        exerciseType: 2,
        groupId: '2',
        hrType: 0,
        id: '3',
        intensityCustom: 2,
        intensityDisplayUnit: 0,
        intensityMultiplier: 0,
        intensityPercent: 0,
        intensityPercentExtend: 0,
        intensityType: 10,
        intensityValue: 0,
        intensityValueExtend: 0,
        isDefaultAdd: 1,
        isGroup: false,
        isIntensityPercent: false,
        name: 'T3001',
        originId: '426109589008859136',
        overview: 'sid_run_training',
        part: [0],
        restType: 3,
        restValue: 0,
        sets: 1,
        sortNo: 3,
        sourceId: '0',
        sourceUrl: '',
        sportType: 6,
        subType: 0,
        targetDisplayUnit: 0,
        targetType: 9,
        targetValue: 4,
        userId: 0,
        videoUrl: '',
        onsightGradeOffset: 32
      },
      {
        access: 0,
        createTimestamp: 1586584214,
        defaultOrder: 3,
        equipment: [1],
        exerciseType: 4,
        groupId: '2',
        hrType: 3,
        id: '4',
        intensityCustom: 2,
        intensityDisplayUnit: 0,
        intensityMultiplier: 0,
        intensityPercent: 0,
        intensityPercentExtend: 0,
        intensityType: 10,
        intensityValue: 0,
        intensityValueExtend: 0,
        isDefaultAdd: 0,
        isGroup: false,
        isIntensityPercent: false,
        name: 'T1123',
        originId: '425895398452936705',
        overview: 'sid_run_cool_down_dist',
        part: [0],
        restType: 3,
        restValue: 0,
        sets: 1,
        sortNo: 4,
        sourceId: '0',
        sourceUrl: '',
        sportType: 6,
        subType: 0,
        targetDisplayUnit: 0,
        targetType: 9,
        targetValue: 1,
        userId: 0,
        videoUrl: '',
        onsightGradeOffset: 30
      },
      {
        access: 0,
        createTimestamp: 1586584214,
        defaultOrder: 3,
        equipment: [1],
        exerciseType: 3,
        groupId: '0',
        hrType: 3,
        id: '5',
        intensityCustom: 2,
        intensityDisplayUnit: 0,
        intensityMultiplier: 0,
        intensityPercent: 0,
        intensityPercentExtend: 0,
        intensityType: 10,
        intensityValue: 0,
        intensityValueExtend: 0,
        isDefaultAdd: 0,
        isGroup: false,
        isIntensityPercent: false,
        name: 'T1122',
        originId: '425895456971866112',
        overview: 'sid_run_cool_down_dist',
        part: [0],
        restType: 3,
        restValue: 0,
        sets: 1,
        sortNo: 5,
        sourceId: '0',
        sourceUrl: '',
        sportType: 6,
        subType: 0,
        targetDisplayUnit: 0,
        targetType: 9,
        targetValue: 2,
        userId: 0,
        videoUrl: '',
        onsightGradeOffset: 30
      }
    ],
    headPic: '',
    id: '0',
    idInPlan: '0',
    name: '',
    nickname: '',
    originEssence: 0,
    overview: '',
    pbVersion: 7,
    planIdIndex: 0,
    poolLength: 0,
    profile: '',
    referExercise: {
      hrType: 0,
      intensityType: 10
    },
    sex: 0,
    shareUrl: '',
    simple: false,
    sourceUrl: '',
    sportType: 6,
    star: 0,
    subType: 65535,
    targetType: 0,
    targetValue: 0,
    thirdPartyId: 0,
    totalSets: 0,
    trainingLoad: 0,
    type: 0,
    unit: 0,
    userId: '0',
    version: 0,
    videoCoverUrl: '',
    videoUrl: '',
    gradeSystemVersion: 1
  },
  bouldering: {
    access: 0,
    authorId: '0',
    createTimestamp: 0,
    distance: 0,
    duration: 0,
    essence: 0,
    estimatedType: 0,
    estimatedValue: 0,
    exerciseNum: 0,
    exercises: [
      {
        access: 0,
        createTimestamp: 1586584068,
        defaultOrder: 1,
        equipment: [1],
        exerciseType: 1,
        groupId: '0',
        hrType: 0,
        id: '1',
        intensityCustom: 0,
        intensityDisplayUnit: 0,
        intensityMultiplier: 0,
        intensityPercent: 0,
        intensityPercentExtend: 0,
        intensityType: 10,
        intensityValue: 0,
        intensityValueExtend: 0,
        isDefaultAdd: 0,
        isGroup: false,
        isIntensityPercent: false,
        name: 'T1120',
        originId: '425895398452936705',
        overview: 'sid_run_warm_up_dist',
        part: [0],
        restType: 3,
        restValue: 0,
        sets: 1,
        sortNo: 1,
        sourceId: '0',
        sourceUrl: '',
        sportType: 7,
        subType: 0,
        targetDisplayUnit: 0,
        targetType: 9,
        targetValue: 2,
        userId: 0,
        videoUrl: '',
        onsightGradeOffset: 30
      },
      {
        access: 0,
        createTimestamp: 0,
        defaultOrder: 0,
        exerciseType: 0,
        groupId: '0',
        hrType: 0,
        id: '2',
        intensityCustom: 0,
        intensityDisplayUnit: 0,
        intensityMultiplier: 0,
        intensityPercent: 0,
        intensityPercentExtend: 0,
        intensityType: 10,
        intensityValue: 0,
        intensityValueExtend: 0,
        isDefaultAdd: 0,
        isGroup: true,
        isIntensityPercent: false,
        name: '',
        originId: '2',
        overview: '',
        restType: 0,
        restValue: 0,
        sets: 1,
        sortNo: 2,
        sourceId: '0',
        sourceUrl: '',
        sportType: 7,
        subType: 0,
        targetDisplayUnit: 0,
        targetType: 9,
        targetValue: 1,
        userId: 0,
        videoUrl: '',
        onsightGradeOffset: 0
      },
      {
        access: 0,
        createTimestamp: 1587381919,
        defaultOrder: 2,
        equipment: [1],
        exerciseType: 2,
        groupId: '2',
        hrType: 0,
        id: '3',
        intensityCustom: 2,
        intensityDisplayUnit: 0,
        intensityMultiplier: 0,
        intensityPercent: 0,
        intensityPercentExtend: 0,
        intensityType: 10,
        intensityValue: 0,
        intensityValueExtend: 0,
        isDefaultAdd: 1,
        isGroup: false,
        isIntensityPercent: false,
        name: 'T3001',
        originId: '426109589008859136',
        overview: 'sid_run_training',
        part: [0],
        restType: 3,
        restValue: 0,
        sets: 1,
        sortNo: 3,
        sourceId: '0',
        sourceUrl: '',
        sportType: 7,
        subType: 0,
        targetDisplayUnit: 0,
        targetType: 9,
        targetValue: 4,
        userId: 0,
        videoUrl: '',
        onsightGradeOffset: 32
      },
      {
        access: 0,
        createTimestamp: 1586584214,
        defaultOrder: 3,
        equipment: [1],
        exerciseType: 4,
        groupId: '2',
        hrType: 3,
        id: '4',
        intensityCustom: 2,
        intensityDisplayUnit: 0,
        intensityMultiplier: 0,
        intensityPercent: 0,
        intensityPercentExtend: 0,
        intensityType: 10,
        intensityValue: 0,
        intensityValueExtend: 0,
        isDefaultAdd: 0,
        isGroup: false,
        isIntensityPercent: false,
        name: 'T1123',
        originId: '425895398452936705',
        overview: 'sid_run_cool_down_dist',
        part: [0],
        restType: 3,
        restValue: 0,
        sets: 1,
        sortNo: 4,
        sourceId: '0',
        sourceUrl: '',
        sportType: 7,
        subType: 0,
        targetDisplayUnit: 0,
        targetType: 9,
        targetValue: 1,
        userId: 0,
        videoUrl: '',
        onsightGradeOffset: 30
      },
      {
        access: 0,
        createTimestamp: 1586584214,
        defaultOrder: 3,
        equipment: [1],
        exerciseType: 3,
        groupId: '0',
        hrType: 3,
        id: '5',
        intensityCustom: 2,
        intensityDisplayUnit: 0,
        intensityMultiplier: 0,
        intensityPercent: 0,
        intensityPercentExtend: 0,
        intensityType: 10,
        intensityValue: 0,
        intensityValueExtend: 0,
        isDefaultAdd: 0,
        isGroup: false,
        isIntensityPercent: false,
        name: 'T1122',
        originId: '425895456971866112',
        overview: 'sid_run_cool_down_dist',
        part: [0],
        restType: 3,
        restValue: 0,
        sets: 1,
        sortNo: 5,
        sourceId: '0',
        sourceUrl: '',
        sportType: 7,
        subType: 0,
        targetDisplayUnit: 0,
        targetType: 9,
        targetValue: 2,
        userId: 0,
        videoUrl: '',
        onsightGradeOffset: 30
      }
    ],
    headPic: '',
    id: '0',
    idInPlan: '0',
    name: '',
    nickname: '',
    originEssence: 0,
    overview: '',
    pbVersion: 7,
    planIdIndex: 0,
    poolLength: 0,
    profile: '',
    referExercise: {
      hrType: 0,
      intensityType: 10
    },
    sex: 0,
    shareUrl: '',
    simple: false,
    sourceUrl: '',
    sportType: 7,
    star: 0,
    subType: 65535,
    targetType: 0,
    targetValue: 0,
    thirdPartyId: 0,
    totalSets: 0,
    trainingLoad: 0,
    type: 0,
    unit: 0,
    userId: '0',
    version: 0,
    videoCoverUrl: '',
    videoUrl: '',
    gradeSystemVersion: 1
  }
};

// 处理模板数据
function dealTemplate() {
  const result = templateConfig;
  for (const template of Object.values(result)) {
    template.exercises.forEach((exercise) => {
      if (exercise.isGroup) {
        return;
      }
      exercise.id = exercise.originId || exercise.id;
    });
  }
  return result;
}

export const trainingProgramDefaultData = dealTemplate();

const exerciseConfig = {
  run: [
    {
      access: 0,
      createTimestamp: 1586584068,
      defaultOrder: 1,
      equipment: [1],
      exerciseType: 1,
      groupId: '0',
      hrType: 3,
      id: '1',
      intensityCustom: 2,
      intensityDisplayUnit: 0,
      intensityMultiplier: 0,
      intensityPercent: 0,
      intensityPercentExtend: 0,
      intensityType: 2,
      intensityValue: 0,
      intensityValueExtend: 0,
      isDefaultAdd: 0,
      isGroup: false,
      isIntensityPercent: false,
      name: 'T1120',
      originId: '425895398452936705',
      overview: 'sid_run_warm_up_dist',
      part: [0],
      restType: 3,
      restValue: 0,
      sets: 1,
      sortNo: 1,
      sourceId: '0',
      sourceUrl: '',
      sportType: 1,
      subType: 0,
      targetDisplayUnit: 0,
      targetType: 2,
      targetValue: 300,
      userId: 0,
      videoUrl: ''
    },
    {
      access: 0,
      createTimestamp: 1587381919,
      defaultOrder: 2,
      equipment: [1],
      exerciseType: 2,
      groupId: '0',
      hrType: 3,
      id: '2',
      intensityCustom: 2,
      intensityDisplayUnit: 0,
      intensityMultiplier: 0,
      intensityPercent: 0,
      intensityPercentExtend: 0,
      intensityType: 2,
      intensityValue: 0,
      intensityValueExtend: 0,
      isDefaultAdd: 1,
      isGroup: false,
      isIntensityPercent: false,
      name: 'T3001',
      originId: '426109589008859136',
      overview: 'sid_run_training',
      part: [0],
      restType: 3,
      restValue: 0,
      sets: 1,
      sortNo: 2,
      sourceId: '0',
      sourceUrl: '',
      sportType: 1,
      subType: 0,
      targetDisplayUnit: 0,
      targetType: 2,
      targetValue: 300,
      userId: 0,
      videoUrl: ''
    },
    {
      access: 0,
      createTimestamp: 1586584214,
      defaultOrder: 3,
      equipment: [1],
      exerciseType: 4,
      groupId: '0',
      hrType: 3,
      id: '3',
      intensityCustom: 2,
      intensityDisplayUnit: 0,
      intensityMultiplier: 0,
      intensityPercent: 0,
      intensityPercentExtend: 0,
      intensityType: 2,
      intensityValue: 0,
      intensityValueExtend: 0,
      isDefaultAdd: 0,
      isGroup: false,
      isIntensityPercent: false,
      name: 'T1123',
      originId: '425895398452936705',
      overview: 'sid_run_cool_down_dist',
      part: [0],
      restType: 3,
      restValue: 0,
      sets: 1,
      sortNo: 3,
      sourceId: '0',
      sourceUrl: '',
      sportType: 1,
      subType: 0,
      targetDisplayUnit: 0,
      targetType: 2,
      targetValue: 300,
      userId: 0,
      videoUrl: ''
    },
    {
      access: 0,
      createTimestamp: 1586584214,
      defaultOrder: 3,
      equipment: [1],
      exerciseType: 3,
      groupId: '0',
      hrType: 3,
      id: '4',
      intensityCustom: 2,
      intensityDisplayUnit: 0,
      intensityMultiplier: 0,
      intensityPercent: 0,
      intensityPercentExtend: 0,
      intensityType: 2,
      intensityValue: 0,
      intensityValueExtend: 0,
      isDefaultAdd: 0,
      isGroup: false,
      isIntensityPercent: false,
      name: 'T1122',
      originId: '425895456971866112',
      overview: 'sid_run_cool_down_dist',
      part: [0],
      restType: 3,
      restValue: 0,
      sets: 1,
      sortNo: 4,
      sourceId: '0',
      sourceUrl: '',
      sportType: 1,
      subType: 0,
      targetDisplayUnit: 0,
      targetType: 2,
      targetValue: 300,
      userId: 0,
      videoUrl: ''
    }
  ],
  trailRun: [
    {
      access: 0,
      createTimestamp: 1586584068,
      defaultOrder: 1,
      equipment: [1],
      exerciseType: 1,
      groupId: '0',
      hrType: 3,
      id: '1',
      intensityCustom: 2,
      intensityDisplayUnit: 0,
      intensityMultiplier: 0,
      intensityPercent: 0,
      intensityPercentExtend: 0,
      intensityType: 2,
      intensityValue: 0,
      intensityValueExtend: 0,
      isDefaultAdd: 0,
      isGroup: false,
      isIntensityPercent: false,
      name: 'T1120',
      originId: '425895398452936705',
      overview: 'sid_run_warm_up_dist',
      part: [0],
      restType: 3,
      restValue: 0,
      sets: 1,
      sortNo: 1,
      sourceId: '0',
      sourceUrl: '',
      sportType: 5,
      subType: 0,
      targetDisplayUnit: 0,
      targetType: 2,
      targetValue: 300,
      userId: 0,
      videoUrl: ''
    },
    {
      access: 0,
      createTimestamp: 1587381919,
      defaultOrder: 2,
      equipment: [1],
      exerciseType: 2,
      groupId: '0',
      hrType: 3,
      id: '2',
      intensityCustom: 2,
      intensityDisplayUnit: 0,
      intensityMultiplier: 0,
      intensityPercent: 0,
      intensityPercentExtend: 0,
      intensityType: 2,
      intensityValue: 0,
      intensityValueExtend: 0,
      isDefaultAdd: 1,
      isGroup: false,
      isIntensityPercent: false,
      name: 'T3001',
      originId: '426109589008859136',
      overview: 'sid_run_training',
      part: [0],
      restType: 3,
      restValue: 0,
      sets: 1,
      sortNo: 2,
      sourceId: '0',
      sourceUrl: '',
      sportType: 5,
      subType: 0,
      targetDisplayUnit: 0,
      targetType: 2,
      targetValue: 300,
      userId: 0,
      videoUrl: ''
    },
    {
      access: 0,
      createTimestamp: 1586584214,
      defaultOrder: 3,
      equipment: [1],
      exerciseType: 4,
      groupId: '0',
      hrType: 3,
      id: '3',
      intensityCustom: 2,
      intensityDisplayUnit: 0,
      intensityMultiplier: 0,
      intensityPercent: 0,
      intensityPercentExtend: 0,
      intensityType: 2,
      intensityValue: 0,
      intensityValueExtend: 0,
      isDefaultAdd: 0,
      isGroup: false,
      isIntensityPercent: false,
      name: 'T1123',
      originId: '425895398452936705',
      overview: 'sid_run_cool_down_dist',
      part: [0],
      restType: 3,
      restValue: 0,
      sets: 1,
      sortNo: 3,
      sourceId: '0',
      sourceUrl: '',
      sportType: 5,
      subType: 0,
      targetDisplayUnit: 0,
      targetType: 2,
      targetValue: 300,
      userId: 0,
      videoUrl: ''
    },
    {
      access: 0,
      createTimestamp: 1586584214,
      defaultOrder: 3,
      equipment: [1],
      exerciseType: 3,
      groupId: '0',
      hrType: 3,
      id: '4',
      intensityCustom: 2,
      intensityDisplayUnit: 0,
      intensityMultiplier: 0,
      intensityPercent: 0,
      intensityPercentExtend: 0,
      intensityType: 2,
      intensityValue: 0,
      intensityValueExtend: 0,
      isDefaultAdd: 0,
      isGroup: false,
      isIntensityPercent: false,
      name: 'T1122',
      originId: '425895456971866112',
      overview: 'sid_run_cool_down_dist',
      part: [0],
      restType: 3,
      restValue: 0,
      sets: 1,
      sortNo: 4,
      sourceId: '0',
      sourceUrl: '',
      sportType: 5,
      subType: 0,
      targetDisplayUnit: 0,
      targetType: 2,
      targetValue: 300,
      userId: 0,
      videoUrl: ''
    }
  ],
  bike: [
    {
      access: 0,
      createTimestamp: 1586585721,
      defaultOrder: 1,
      equipment: [1],
      exerciseType: 1,
      groupId: '0',
      hrType: 3,
      id: '1',
      intensityCustom: 2,
      intensityDisplayUnit: 0,
      intensityMultiplier: 0,
      intensityPercent: 0,
      intensityPercentExtend: 0,
      intensityType: 2,
      intensityValue: 0,
      intensityValueExtend: 0,
      isDefaultAdd: 0,
      isGroup: false,
      isIntensityPercent: false,
      name: 'T1120',
      originId: '425895398452936705',
      overview: 'sid_bike_warm_up_dist',
      part: [0],
      restType: 3,
      restValue: 0,
      sets: 1,
      sortNo: 1,
      sourceId: '0',
      sourceUrl: '',
      sportType: 2,
      subType: 0,
      targetDisplayUnit: 0,
      targetType: 2,
      targetValue: 300,
      userId: 0,
      videoUrl: ''
    },
    {
      access: 0,
      createTimestamp: 1586585061,
      defaultOrder: 2,
      equipment: [1],
      exerciseType: 2,
      groupId: '0',
      hrType: 3,
      id: '2',
      intensityCustom: 2,
      intensityDisplayUnit: 0,
      intensityMultiplier: 0,
      intensityPercent: 0,
      intensityPercentExtend: 0,
      intensityType: 2,
      intensityValue: 0,
      intensityValueExtend: 0,
      isDefaultAdd: 1,
      isGroup: false,
      isIntensityPercent: false,
      name: 'T4000',
      originId: '426109589008859136',
      overview: 'sid_bike_dist_speed',
      part: [0],
      restType: 3,
      restValue: 0,
      sets: 1,
      sortNo: 2,
      sourceId: '0',
      sourceUrl: '',
      sportType: 2,
      subType: 0,
      targetDisplayUnit: 0,
      targetType: 2,
      targetValue: 300,
      userId: 0,
      videoUrl: ''
    },
    {
      access: 0,
      createTimestamp: 1586585838,
      defaultOrder: 3,
      equipment: [1],
      exerciseType: 4,
      groupId: '0',
      hrType: 3,
      id: '3',
      intensityCustom: 2,
      intensityDisplayUnit: 0,
      intensityMultiplier: 0,
      intensityPercent: 0,
      intensityPercentExtend: 0,
      intensityType: 2,
      intensityValue: 0,
      intensityValueExtend: 0,
      isDefaultAdd: 0,
      isGroup: false,
      isIntensityPercent: false,
      name: 'T1123',
      originId: '425895398452936705',
      overview: 'sid_bike_cool_down_dist',
      part: [0],
      restType: 3,
      restValue: 0,
      sets: 1,
      sortNo: 3,
      sourceId: '0',
      sourceUrl: '',
      sportType: 2,
      subType: 0,
      targetDisplayUnit: 0,
      targetType: 2,
      targetValue: 300,
      userId: 0,
      videoUrl: ''
    },
    {
      access: 0,
      createTimestamp: 1586585838,
      defaultOrder: 3,
      equipment: [1],
      exerciseType: 3,
      groupId: '0',
      hrType: 3,
      id: '4',
      intensityCustom: 2,
      intensityDisplayUnit: 0,
      intensityMultiplier: 0,
      intensityPercent: 0,
      intensityPercentExtend: 0,
      intensityType: 2,
      intensityValue: 0,
      intensityValueExtend: 0,
      isDefaultAdd: 0,
      isGroup: false,
      isIntensityPercent: false,
      name: 'T1122',
      originId: '425895456971866112',
      overview: 'sid_bike_cool_down_dist',
      part: [0],
      restType: 3,
      restValue: 0,
      sets: 1,
      sortNo: 4,
      sourceId: '0',
      sourceUrl: '',
      sportType: 2,
      subType: 0,
      targetDisplayUnit: 0,
      targetType: 2,
      targetValue: 300,
      userId: 0,
      videoUrl: ''
    }
  ],
  swim: [
    // 热身
    {
      access: 0,
      createTimestamp: 1586586898,
      defaultOrder: 1,
      equipment: [1],
      exerciseType: 1,
      groupId: '0',
      hrType: 0,
      id: '1',
      intensityCustom: 0,
      intensityDisplayUnit: 0,
      intensityMultiplier: 0,
      intensityPercent: 0,
      intensityPercentExtend: 0,
      intensityType: 5,
      intensityValue: 1,
      intensityValueExtend: 0,
      isDefaultAdd: 0,
      isGroup: false,
      isIntensityPercent: false,
      name: 'T1120',
      originId: '425895398452936705',
      overview: 'sid_poolswim_warm_up_dist',
      part: [0],
      restType: 3,
      restValue: 0,
      sets: 1,
      sortNo: 1,
      sourceId: '0',
      sourceUrl: '',
      sportType: 3,
      subType: 0,
      targetDisplayUnit: 2,
      targetType: 5,
      targetValue: 10000000,
      userId: 0,
      videoUrl: ''
    },
    // 包干训练
    {
      access: 0,
      createTimestamp: 1586586898,
      defaultOrder: 4,
      equipment: [1],
      exerciseType: 5,
      groupId: '0',
      hrType: 0,
      id: '5',
      intensityCustom: 0,
      intensityDisplayUnit: 0,
      intensityMultiplier: 0,
      intensityPercent: 0,
      intensityPercentExtend: 0,
      intensityType: 5,
      intensityValue: 1,
      intensityValueExtend: 0,
      isDefaultAdd: 0,
      isGroup: false,
      isIntensityPercent: false,
      name: 'T5065',
      originId: '425895398452936705',
      overview: 'sid_poolswim_warm_up_dist',
      part: [0],
      restType: 3,
      restValue: 0,
      sets: 1,
      sortNo: 1,
      sourceId: '0',
      sourceUrl: '',
      sportType: 3,
      subType: 1,
      targetDisplayUnit: 0,
      targetType: 5,
      targetValue: 10000000,
      userId: 0,
      videoUrl: ''
    },
    // 训练
    {
      access: 0,
      createTimestamp: 1586586026,
      defaultOrder: 2,
      equipment: [1],
      exerciseType: 2,
      groupId: '0',
      hrType: 0,
      id: '2',
      intensityCustom: 0,
      intensityDisplayUnit: 0,
      intensityMultiplier: 0,
      intensityPercent: 0,
      intensityPercentExtend: 0,
      intensityType: 5,
      intensityValue: 1,
      intensityValueExtend: 0,
      isDefaultAdd: 1,
      isGroup: false,
      isIntensityPercent: false,
      name: 'T5000',
      originId: '426109589008859136',
      overview: 'sid_poolswim_dist_default',
      part: [0],
      restType: 3,
      restValue: 0,
      sets: 1,
      sortNo: 2,
      sourceId: '0',
      sourceUrl: '',
      sportType: 3,
      subType: 0,
      targetDisplayUnit: 2,
      targetType: 5,
      targetValue: 10000000,
      userId: 0,
      videoUrl: ''
    },
    // 休息
    {
      access: 0,
      createTimestamp: 1586587031,
      defaultOrder: 3,
      equipment: [1],
      exerciseType: 4,
      groupId: '0',
      hrType: 0,
      id: '3',
      intensityCustom: 0,
      intensityDisplayUnit: 0,
      intensityMultiplier: 0,
      intensityPercent: 0,
      intensityPercentExtend: 0,
      intensityType: 5,
      intensityValue: 1,
      intensityValueExtend: 0,
      isDefaultAdd: 0,
      isGroup: false,
      isIntensityPercent: false,
      name: 'T1123',
      originId: '425895398452936705',
      overview: 'sid_poolswim_cool_down_dist',
      part: [0],
      restType: 3,
      restValue: 0,
      sets: 1,
      sortNo: 3,
      sourceId: '0',
      sourceUrl: '',
      sportType: 3,
      subType: 0,
      targetDisplayUnit: 0,
      targetType: 2,
      targetValue: 300,
      userId: 0,
      videoUrl: ''
    },
    // 恢复
    {
      access: 0,
      createTimestamp: 1586587031,
      defaultOrder: 3,
      equipment: [1],
      exerciseType: 3,
      groupId: '0',
      hrType: 0,
      id: '4',
      intensityCustom: 0,
      intensityDisplayUnit: 0,
      intensityMultiplier: 0,
      intensityPercent: 0,
      intensityPercentExtend: 0,
      intensityType: 5,
      intensityValue: 0,
      intensityValueExtend: 0,
      isDefaultAdd: 0,
      isGroup: false,
      isIntensityPercent: false,
      name: 'T1122',
      originId: '425895456971866112',
      overview: 'sid_poolswim_cool_down_dist',
      part: [0],
      restType: 3,
      restValue: 0,
      sets: 1,
      sortNo: 4,
      sourceId: '0',
      sourceUrl: '',
      sportType: 3,
      subType: 0,
      targetDisplayUnit: 2,
      targetType: 5,
      targetValue: 10000000,
      userId: 0,
      videoUrl: ''
    }
  ],
  strength: [],
  indoorClimb: [
    {
      access: 0,
      createTimestamp: 1586586898,
      defaultOrder: 1,
      equipment: [1],
      exerciseType: 1,
      groupId: '0',
      hrType: 0,
      id: '1',
      intensityCustom: 0,
      intensityDisplayUnit: 0,
      intensityMultiplier: 0,
      intensityPercent: 0,
      intensityPercentExtend: 0,
      intensityType: 10,
      intensityValue: 1,
      intensityValueExtend: 0,
      isDefaultAdd: 0,
      isGroup: false,
      isIntensityPercent: false,
      name: 'T1120',
      originId: '425895398452936705',
      overview: 'sid_poolswim_warm_up_dist',
      part: [0],
      restType: 0,
      restValue: 0,
      sets: 1,
      sortNo: 1,
      sourceId: '0',
      sourceUrl: '',
      sportType: 6,
      subType: 0,
      targetDisplayUnit: 0,
      targetType: 9,
      targetValue: 2,
      userId: 0,
      videoUrl: '',
      onsightGradeOffset: 0
    },
    {
      access: 0,
      createTimestamp: 1586586026,
      defaultOrder: 2,
      equipment: [1],
      exerciseType: 2,
      groupId: '0',
      hrType: 0,
      id: '2',
      intensityCustom: 0,
      intensityDisplayUnit: 0,
      intensityMultiplier: 0,
      intensityPercent: 0,
      intensityPercentExtend: 0,
      intensityType: 10,
      intensityValue: 1,
      intensityValueExtend: 0,
      isDefaultAdd: 1,
      isGroup: false,
      isIntensityPercent: false,
      name: 'T5000',
      originId: '426109589008859136',
      overview: 'sid_poolswim_dist_default',
      part: [0],
      restType: 0,
      restValue: 0,
      sets: 1,
      sortNo: 2,
      sourceId: '0',
      sourceUrl: '',
      sportType: 6,
      subType: 0,
      targetDisplayUnit: 0,
      targetType: 9,
      targetValue: 4,
      userId: 0,
      videoUrl: '',
      onsightGradeOffset: 0
    },
    {
      access: 0,
      createTimestamp: 1586587031,
      defaultOrder: 3,
      equipment: [1],
      exerciseType: 4,
      groupId: '0',
      hrType: 0,
      id: '3',
      intensityCustom: 0,
      intensityDisplayUnit: 0,
      intensityMultiplier: 0,
      intensityPercent: 0,
      intensityPercentExtend: 0,
      intensityType: 10,
      intensityValue: 1,
      intensityValueExtend: 0,
      isDefaultAdd: 0,
      isGroup: false,
      isIntensityPercent: false,
      name: 'T1123',
      originId: '425895398452936705',
      overview: 'sid_poolswim_cool_down_dist',
      part: [0],
      restType: 0,
      restValue: 0,
      sets: 1,
      sortNo: 3,
      sourceId: '0',
      sourceUrl: '',
      sportType: 6,
      subType: 0,
      targetDisplayUnit: 0,
      targetType: 9,
      targetValue: 1,
      userId: 0,
      videoUrl: '',
      onsightGradeOffset: 0
    },
    {
      access: 0,
      createTimestamp: 1586587031,
      defaultOrder: 3,
      equipment: [1],
      exerciseType: 3,
      groupId: '0',
      hrType: 0,
      id: '4',
      intensityCustom: 0,
      intensityDisplayUnit: 0,
      intensityMultiplier: 0,
      intensityPercent: 0,
      intensityPercentExtend: 0,
      intensityType: 10,
      intensityValue: 1,
      intensityValueExtend: 0,
      isDefaultAdd: 0,
      isGroup: false,
      isIntensityPercent: false,
      name: 'T1122',
      originId: '425895456971866112',
      overview: 'sid_poolswim_cool_down_dist',
      part: [0],
      restType: 0,
      restValue: 0,
      sets: 1,
      sortNo: 4,
      sourceId: '0',
      sourceUrl: '',
      sportType: 6,
      subType: 0,
      targetDisplayUnit: 0,
      targetType: 9,
      targetValue: 2,
      userId: 0,
      videoUrl: '',
      onsightGradeOffset: 0
    }
  ],
  bouldering: [
    {
      access: 0,
      createTimestamp: 1586586898,
      defaultOrder: 1,
      equipment: [1],
      exerciseType: 1,
      groupId: '0',
      hrType: 0,
      id: '1',
      intensityCustom: 0,
      intensityDisplayUnit: 0,
      intensityMultiplier: 0,
      intensityPercent: 0,
      intensityPercentExtend: 0,
      intensityType: 10,
      intensityValue: 1,
      intensityValueExtend: 0,
      isDefaultAdd: 0,
      isGroup: false,
      isIntensityPercent: false,
      name: 'T1120',
      originId: '425895398452936705',
      overview: 'sid_poolswim_warm_up_dist',
      part: [0],
      restType: 0,
      restValue: 0,
      sets: 1,
      sortNo: 1,
      sourceId: '0',
      sourceUrl: '',
      sportType: 7,
      subType: 0,
      targetDisplayUnit: 0,
      targetType: 9,
      targetValue: 2,
      userId: 0,
      videoUrl: '',
      onsightGradeOffset: 0
    },
    {
      access: 0,
      createTimestamp: 1586586026,
      defaultOrder: 2,
      equipment: [1],
      exerciseType: 2,
      groupId: '0',
      hrType: 0,
      id: '2',
      intensityCustom: 0,
      intensityDisplayUnit: 0,
      intensityMultiplier: 0,
      intensityPercent: 0,
      intensityPercentExtend: 0,
      intensityType: 10,
      intensityValue: 1,
      intensityValueExtend: 0,
      isDefaultAdd: 1,
      isGroup: false,
      isIntensityPercent: false,
      name: 'T5000',
      originId: '426109589008859136',
      overview: 'sid_poolswim_dist_default',
      part: [0],
      restType: 0,
      restValue: 0,
      sets: 1,
      sortNo: 2,
      sourceId: '0',
      sourceUrl: '',
      sportType: 7,
      subType: 0,
      targetDisplayUnit: 0,
      targetType: 9,
      targetValue: 4,
      userId: 0,
      videoUrl: '',
      onsightGradeOffset: 0
    },
    {
      access: 0,
      createTimestamp: 1586587031,
      defaultOrder: 3,
      equipment: [1],
      exerciseType: 4,
      groupId: '0',
      hrType: 0,
      id: '3',
      intensityCustom: 0,
      intensityDisplayUnit: 0,
      intensityMultiplier: 0,
      intensityPercent: 0,
      intensityPercentExtend: 0,
      intensityType: 10,
      intensityValue: 1,
      intensityValueExtend: 0,
      isDefaultAdd: 0,
      isGroup: false,
      isIntensityPercent: false,
      name: 'T1123',
      originId: '425895398452936705',
      overview: 'sid_poolswim_cool_down_dist',
      part: [0],
      restType: 0,
      restValue: 0,
      sets: 1,
      sortNo: 3,
      sourceId: '0',
      sourceUrl: '',
      sportType: 7,
      subType: 0,
      targetDisplayUnit: 0,
      targetType: 9,
      targetValue: 1,
      userId: 0,
      videoUrl: '',
      onsightGradeOffset: 0
    },
    {
      access: 0,
      createTimestamp: 1586587031,
      defaultOrder: 3,
      equipment: [1],
      exerciseType: 3,
      groupId: '0',
      hrType: 0,
      id: '4',
      intensityCustom: 0,
      intensityDisplayUnit: 0,
      intensityMultiplier: 0,
      intensityPercent: 0,
      intensityPercentExtend: 0,
      intensityType: 10,
      intensityValue: 1,
      intensityValueExtend: 0,
      isDefaultAdd: 0,
      isGroup: false,
      isIntensityPercent: false,
      name: 'T1122',
      originId: '425895456971866112',
      overview: 'sid_poolswim_cool_down_dist',
      part: [0],
      restType: 0,
      restValue: 0,
      sets: 1,
      sortNo: 4,
      sourceId: '0',
      sourceUrl: '',
      sportType: 7,
      subType: 0,
      targetDisplayUnit: 0,
      targetType: 9,
      targetValue: 2,
      userId: 0,
      videoUrl: '',
      onsightGradeOffset: 0
    }
  ]
};

// 处理动作数据
function dealExercise() {
  const result = exerciseConfig;
  for (const list of Object.values(result)) {
    list.forEach((exercise) => {
      exercise.id = exercise.originId || exercise.id;
    });
  }
  return result;
}

export const defaultExerciseConfigs = dealExercise();
